export const menuAdmin: {
	code: string;
	icon: string;
	action?: () => void;
}[] = [
	{ code: "DASH_VIEW", icon: "content-paste-outlined" },
	{ code: "DASH_NEW_VIEW", icon: "assessment-outlined" },
	{ code: "PART_VIEW", icon: "person-outlined" },
	{ code: "USER_MNG_VIEW", icon: "group-outlined" },
	{ code: "ACCOUNT_VIEW", icon: "settings-outlined" },
	{ code: "PROG_MNG_VIEW", icon: "programs-config" },
	{ code: "ROLE_MNG_VIEW", icon: "hub-outlined" },
	{ code: "OU_CONF_VIEW", icon: "domain-outlined" },
	{ code: "GROUP_LABEL_CONF_VIEW", icon: "domain-outlined" },
	{ code: "REP_VIEW", icon: "note-outlined" },
	{ code: "REP_BEN_VIEW", icon: "assessment-outlined" },
	{ code: "REP_PROV_VIEW", icon: "assessment-outlined" },
	{ code: "REP_PIHP_VIEW", icon: "assessment-outlined" },
	{ code: "REP_PROG_OVER_VIEW", icon: "assessment-outlined" },
	{ code: "REP_USER_INVI_VIEW", icon: "assessment-outlined" },
	{ code: "REP_DASH_VIEW", icon: "assessment-outlined" },
	{ code: "REP_DASH_ASSISTANT_VIEW", icon: "assessment-outlined" },
	{ code: "REP_DASH_ENROLLMENT_VIEW", icon: "assessment-outlined" },
	{ code: "REP_DASH_ACTIVITY_VIEW", icon: "assessment-outlined" },
	{ code: "REP_DASH_VISIT_VIEW", icon: "assessment-outlined" },
	// SIMS-8161: Disbursed Incentives report — independently granted menu option.
	{ code: "REP_DASH_DISBURSED_VIEW", icon: "assessment-outlined" },
	{ code: "HELP_SUPPORT_VIEW", icon: "help-outline-outlined" },
	{ code: "AWS_ACCESS", icon: "content-paste-outlined" },
	{ code: "PHY_CARD_ORDER", icon: "credit-card" },
	// SIMS-9441: App versions maintenance.
	{ code: "APP_VERSION_VIEW", icon: "settings-outlined" },
];

export const getIconOrDefault = (code: string) => {
	const icon = menuAdmin.find((item) => item.code === code);
	if (icon) return icon.icon;
	return "content-paste-outlined";
};
